/** Dars yakuni ekrani (demo `finish` ning ko'rinish qismi; hisob `engine.finish()` → `L.summary`). */
import { t, tn } from '../../i18n';
import { nav } from '../../lib/nav';
import { toast } from '../../lib/toast';
import { useStore } from '../../store';
import { Ic } from '../../ui/Icon';
import { startPractice, useLesson } from './engine';

export function Finish() {
  const L = useLesson((st) => st.L);
  const streak = useStore((s) => s.streak);
  if (!L?.summary) return null;
  const { nN, nR, acc, words, wrong, title, xp } = L.summary;
  const lesson = L.mode === 'lesson';

  const home = () => { useLesson.getState().reset(); nav.home('home'); };
  const redo = () => { useLesson.getState().reset(); nav.pop(); startPractice(wrong, 'Xatolar ustida ishlash'); };
  const share = () => {
    const txt = t(`Lexo: bugun ${lesson ? nN + ' ta yangi soʻz, ' : ''}${acc}% aniqlik, ${streak} kunlik streak!`);
    try { navigator.clipboard.writeText(txt).then(() => toast(t('Natija nusxalandi')), () => toast(txt)); } catch { toast(txt); }
  };

  return (
    <>
      <div className="content fade" style={{ paddingTop: 32, gap: 18 }}>
        <div className="col g12" style={{ alignItems: 'center', textAlign: 'center' }}>
          <div className="flamebig"><Ic n="flame" /></div>
          <h1 className="h2">{t(title)}</h1>
          <span className="soon" style={{ fontSize: 15, padding: '6px 14px' }}>{tn('# kunlik streak', streak)}</span>
        </div>
        <div className="stat3 center">
          <div><b style={{ color: 'var(--primary-ink)' }}>+{xp}</b><span>XP</span></div>
          <div><b>{lesson ? `${nN} + ${nR}` : L.tot}</b><span>{lesson ? t('yangi + takror') : t('savol')}</span></div>
          <div><b style={{ color: 'var(--success-ink)' }}>{acc}%</b><span>{t('aniqlik')}</span></div>
        </div>
        {words.length > 0 && (
          <div className="learned">
            <div className="cap">{lesson ? t('Bugun oʻrganildi') : t('Mashq qilingan soʻzlar')}</div>
            {words.map((w) => <div key={w.id} className="between"><b>{w.w}</b><span>{w.uz}</span></div>)}
          </div>
        )}
        {wrong.length > 0 && (
          <button className="mist" id="redo" onClick={redo}>
            <span className="grow" style={{ textAlign: 'left' }}>{tn('# ta xato · Qayta ishlash', wrong.length)}</span>
            <Ic n="chevRight" style={{ width: 20, height: 20 }} />
          </button>
        )}
      </div>
      <div className="sfoot">
        <button className="btn soft sq" id="sh" aria-label={t('Natijani nusxalash')} onClick={share}><Ic n="share" /></button>
        <button className="btn" id="hm" onClick={home}>{t('Bosh sahifaga')}</button>
      </div>
    </>
  );
}
